import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { Videocam } from "@mui/icons-material";
import { cameraAvailability } from "../../model/cameraModel";

function TableCamaras({ camaras, checkingStatus, onConsultar }) {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  useEffect(() => setPage(0), [camaras]);
  return (
    <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden" }}>
      <Box sx={{ p: 2.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#213e54" }}>
          Cámaras registradas <Chip size="small" label={camaras.length} sx={{ ml: 1 }} />
        </Typography>
        <Typography variant="body2" sx={{ color: "#586d80", mt: 0.5 }}>
          La disponibilidad corresponde al monitoreo. Consulta el equipo para obtener sus métricas
          actuales.
        </Typography>
      </Box>
      <TableContainer>
        <Table
          sx={{
            minWidth: 850,
            "& th": { bgcolor: "#edf3f8", color: "#3d5970", fontSize: 12, fontWeight: 700 },
            "& td": { fontSize: 13, color: "#253f53", borderColor: "#edf1f5" },
          }}
        >
          <TableHead sx={{ display: "table-header-group" }}>
            <TableRow>
              {["Cámara / comercio", "IP / host", "Disponibilidad", "Monitoreo", ""].map(
                (label) => (
                  <TableCell key={label}>{label}</TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {camaras.slice(page * perPage, page * perPage + perPage).map((camera, index) => {
              const state = cameraAvailability(camera);
              return (
                <TableRow key={`${camera.hostid}-${camera.ip}-${index}`} hover>
                  <TableCell>
                    <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                      <Videocam sx={{ color: "#497aa0" }} />
                      <Box>
                        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                          {camera.name}
                        </Typography>
                        <Typography sx={{ fontSize: 12, color: "#657d90" }}>
                          {camera.commerceName}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ fontFamily: "monospace", fontWeight: 600 }}>
                      {camera.ip || "Sin IP"}
                    </Box>
                    <Typography variant="caption">Host {camera.hostid || "—"}</Typography>
                  </TableCell>
                  <TableCell>
                    <Tooltip title={camera.error || "Disponibilidad reportada por el monitoreo"}>
                      <Chip
                        label={state.label}
                        color={state.color}
                        size="small"
                        variant="outlined"
                      />
                    </Tooltip>
                    {camera.error && (
                      <Typography
                        sx={{
                          fontSize: 11,
                          color: "#a52d3b",
                          maxWidth: 240,
                          mt: 0.5,
                          overflowWrap: "anywhere",
                        }}
                      >
                        {camera.error}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: 12 }}>
                      {camera.status === 0
                        ? "Habilitado"
                        : camera.status === 1
                        ? "Deshabilitado"
                        : "Sin información"}
                    </Typography>
                    {camera.maintenance_status === 1 && (
                      <Chip
                        label="En mantenimiento"
                        size="small"
                        sx={{ mt: 0.5, bgcolor: "#eef0fb", color: "#4657a1" }}
                      />
                    )}
                  </TableCell>
                  <TableCell align="right">
                    <Button
                      variant="outlined"
                      size="small"
                      disabled={!camera.ip || checkingStatus}
                      onClick={() => onConsultar(camera.ip)}
                      sx={{
                        "&&": { color: "#245e89", borderColor: "#9bb7ce" },
                        "&&.Mui-disabled": { color: "#8392a0", borderColor: "#dce3ea" },
                      }}
                    >
                      Consultar
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
            {!camaras.length && (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 6 }}>
                  No hay cámaras que coincidan con los filtros.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={camaras.length}
        page={page}
        onPageChange={(_, value) => setPage(value)}
        rowsPerPage={perPage}
        onRowsPerPageChange={(e) => {
          setPerPage(Number(e.target.value));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 25, 50]}
        labelRowsPerPage="Cámaras por página"
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
      />
    </Paper>
  );
}
TableCamaras.propTypes = {
  camaras: PropTypes.array.isRequired,
  checkingStatus: PropTypes.bool,
  onConsultar: PropTypes.func.isRequired,
};
export default TableCamaras;
